import React, { type ReactElement } from 'react';

import styles from './Placeholder.css';

export const Placeholder = (): ReactElement => <div className={styles.root} />;
